import React from 'react'
import { getSkeletonSize } from './helpers'
import type { ProductTileSize } from '@/tools/ui'
import { Skeleton } from '@/tools/ui'

export const ProductTileSkeleton: React.FC<{ size: ProductTileSize }> = ({ size }) => {
  const skeletonSize = getSkeletonSize(size)

  return (
    <Skeleton animated>
      <svg
        className="pintxo-skeleton-shape"
        height={skeletonSize + 50}
        width={skeletonSize}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <rect height={skeletonSize} rx="16" ry="16" width="100%" x="0" y="0" />
          <rect height="20" rx="10" ry="10" width="100%" x="0" y={skeletonSize + 8} />
          <rect height="20" rx="10" ry="10" width="40%" x="0" y={skeletonSize + 30} />
        </g>
      </svg>
    </Skeleton>
  )
}
